// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"_cc230d5"};